module.exports = __webpack_public_path__ + "img/img-6.370b44d2.jpg";